import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { ISettingsPrintMode } from './settings-print-mode.model';

@Injectable()
export class SettingsJobsAssignmentPrintModeService {

    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private translation: NDDTranslationService,
        private loggerService: LoggerService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-jobs-assignment`;
    }

    public getPrintModeSettings(): Observable<ISettingsPrintMode> {
        return this.http.get<ISettingsPrintMode>(`${ this.apiUrl }/print-mode`);
    }

    public updatePrintMode(printMode: any): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/update-private-print-enabled`, printMode).pipe(tap(() => {
            this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')]);
        }));
    }
}
